import { gql } from '@apollo/client';

export const GET_APPLICATION_OPEN_SCREEN = gql`
  query ReadApplicationOpenScreenV2(
    $countryCode: CountryCode
    $completedTutorials: [String]
  ) {
    readApplicationOpenScreenV2(
      countryCode: $countryCode
      completedTutorials: $completedTutorials
    ) {
      hasFailedSession
      approveTerms
      tutorialId
    }
  }
`;
